import { GetterTree } from 'vuex'
import { FormsState } from '@/store/modules/forms/formsTypes'
import { RootState } from '@/store/types/storeGlobalTypes'

export const getters: GetterTree<FormsState, RootState> = {
  checkIfFormIsValid:
    (state) =>
    (context: string): boolean => {
      return state.formIsValid[context]
    },
  registerNameFilled(state) {
    return (state as any).registerFormData['name'] ? true : false
  },
  getRegisterFormData(state) {
    return state.registerFormData
  },
  showRelatedForm:
    (state) =>
    (context: string): boolean => {
      return state.showRelatedForm[context]
    },
  showAditionalForm:
    (state) =>
    (context: string): boolean => {
      return state.showAditionalForm[context]
    },
  loadNewRegister: (state) => (context: string) => {
    return state.newRegister[context]
  },
  tryToValidateContactForm(state) {
    return state.validateFormFlag
  },
  getLoadingFormData(state) {
    return state.loadingFormData
  },
  getRelatedData: (state) => (relatedAlias: string) => {
    return state.relatedData[relatedAlias]
  },
  getCustomValidateField: (state) => (key: string) => {
    return state.customValidateField[key]
  },
  getSelectParentFieldValue: (state) => (key: string) => {
    return state.selectedParentField[key]
  },
  getParentFieldValues: (state) => () => {
    return state.parentFieldValues
  },
  getParentFormContext: (state) => () => {
    return state.parentFormContext
  }
}
